export enum PageContext {
  LandingPage = 'LANDING_PAGE',
  ProductPage = 'PRODUCT_PAGE',
  CollectionsPage = 'COLLECTION_PAGE',
  GiftCardPage = 'GIFT_CARD_PAGE',
  CartPage = 'CART_PAGE',
  NonFunnelPage = 'NON_FUNNEL_PAGE',
  ReviewsPage = 'REVIEWS_PAGE',
  AboutPage = 'ABOUT_US_PAGE',
  TrackYourOrderPage = 'TRACK_YOUR_ORDER_PAGE',
  Blog = 'BLOG',
  FourOhFour = '404',
  None = '',
}
